import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            minHeight: '100%',
            maxHeight: '100%'
        },
        footer: {
            position: 'relative'
        }
    }
})